import React, { useRef, useState } from "react";

const KahaniAajKiHome = () => {
  const [tab, setTab] = useState("today");
  const [isPlaying, setIsPlaying] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const audioRef = useRef(null);

  const comments = [
    { user: "Rohit", text: "Dil chhoo lene wali kahani ❤️" },
    { user: "Anita", text: "Voice bahut soothing hai" },
  ];

  const togglePlay = () => {
    if (!audioRef.current) return;
    if (audioRef.current.paused) {
      audioRef.current.play();
      setIsPlaying(true);
    } else {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  const renderStars = () => {
    return [...Array(5)].map((_, i) => {
      const value = i + 1;
      return (
        <i
          key={i}
          onClick={() => setRating(value)}
          className={`cursor-pointer text-yellow-500 text-lg
            ${
              rating >= value
                ? "fa-solid fa-star"
                : rating >= value - 0.5
                ? "fa-solid fa-star-half-stroke"
                : "fa-regular fa-star"
            }
          `}
        ></i>
      );
    });
  };

  return (
    <div className="mx-auto p-2 space-y-2 bg-black">
      <div className="bg-black py-2 text-center border-b border-blue-600">
        <h1 className="text-xl lg:text-2xl font-bold text-yellow-200">
          Aaj Ki Kahani Suno
        </h1>
        {/* <p className="mt-2 text-xs lg:text-lsm text-cyan-200">Daily Essentials Kits for Your Neighborhood</p> */}
      </div>
      <div className="grid grid-cols-4 gap-2 text-xs font-semibold [&_p]:text-white">
        {[
          ["today", "Aaj Ki Kahani"],
          ["history", "History"],
          ["send", "Send Story"],
          ["demand", "Demand"],
        ].map(([key, label]) => (
          <button
            key={key}
            onClick={() => setTab(key)}
            className={`py-2 rounded-md ${
              tab === key
                ? "bg-indigo-600 text-white"
                : "bg-teal-600 text-white"
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {/* ================= Aaj Ki Kahani ================= */}
      {tab === "today" && (
        <div className="space-y-4 [&_p]:text-white">
          <h1 className="text-lg font-bold">आज की कहानी – आत्मबल</h1>

          {/* Banner */}
          <div className="relative rounded-xl overflow-hidden shadow">
            <img
              src="https://via.placeholder.com/400x220"
              className="w-full h-48 object-cover"
              alt="Kahani Banner"
            />
            <button
              onClick={togglePlay}
              className="absolute inset-0 flex items-center justify-center bg-black/40"
            >
              <i
                className={`text-white text-4xl ${
                  isPlaying
                    ? "fa-solid fa-pause fa-beat"
                    : "fa-solid fa-play fa-bounce"
                }`}
              ></i>
            </button>
            <audio ref={audioRef} src="/sample-audio.mp3" />
          </div>

          {/* Meta */}
          <div className="text-sm text-gray-100 space-y-1">
            <p><b>Date:</b> 09 Jan 2026</p>
            <p><b>Description:</b> Ek kahani jo aapko himmat degi.</p>
            <p><b>Posted By:</b> KahaniAajKi</p>
            <p><b>Remarks:</b> Headphones recommended 🎧</p>
          </div>

          {/* Rating */}
          <div className="flex gap-1 items-center">
            {renderStars()}
            <span className="text-xs text-gray-100 ml-2">
              ({rating}/5)
            </span>
          </div>

          {/* Comments */}
          <div className="space-y-2">
            <h3 className="font-semibold text-yellow-200">Comments</h3>
            {comments.map((c, i) => (
              <p key={i} className="text-sm">
                <b>{c.user}:</b> {c.text}
              </p>
            ))}
            <div className="flex gap-2">
              <input
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Apna comment likhein..."
                className="flex-1 border rounded-md px-2 py-1 text-sm"
              />
              <button className="bg-indigo-600 text-white px-2 rounded-md w-20">
                Post
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ================= History ================= */}
      {tab === "history" && (
        <div className="space-y-3">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="border rounded-lg p-3 flex justify-between items-center [&_p]:text-white"
            >
              <div className="text-sm space-y-1">
                <p className="font-semibold">Kahani #{i}</p>
                <p>Date: 07 Jan 2026</p>
                <p>Posted By: Admin</p>
              </div>
              <i className="fa-solid fa-play text-indigo-600 text-xl cursor-pointer"></i>
            </div>
          ))}
        </div>
      )}

      {/* ================= Send Story ================= */}
      {tab === "send" && (
        <div className="space-y-3 [&_p]:text-white">
          <h3 className="font-semibol text-yellow-200">Send Your Story</h3>
          <textarea
            rows="5"
            placeholder="Apni kahani likhein..."
            className="w-full border rounded-md p-2 text-sm"
          ></textarea>
          <button className="w-40 bg-indigo-600 text-white py-2 rounded-md">
            Submit Story
          </button>
        </div>
      )}

      {/* ================= Demand Story ================= */}
      {tab === "demand" && (
        <div className="space-y-3 [&_p]:text-white">
          <h3 className="font-semibold text-yellow-200">Demand a Story</h3>
          <input
            placeholder="Kaunsi kahani sunni hai?"
            className="w-full border rounded-md p-2 text-sm"
          />
          <select className="w-32 h-10 border rounded-md p-2 text-sm">
            <option>Male Voice</option>
            <option>Female Voice</option>
          </select>
          <input
            placeholder="Personality (e.g. APJ Abdul Kalam)"
            className="w-full border rounded-md p-2 text-sm"
          />
          <button className="w-40 bg-indigo-600 text-white py-2 rounded-md">
            Request Story
          </button>
        </div>
      )}
    </div>
  );
};

export default KahaniAajKiHome;
